<template>
  <v-card>
    <v-data-table
        :items="handling.items"
        :headers="headers"
    >
        <template #[`item.product`]="{item}" >
            <v-tooltip bottom>
                <template #activator="{on, attrs}">
                    <span v-on="on" v-bind="attrs">
                        {{ item.product.name }}
                    </span>
                </template>
                {{ item.product.sku }}
            </v-tooltip>
        </template>
        <template #[`item.actions`]="{item}">
            <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        small
                        color="primary"
                        dark
                        v-bind="attrs"
                        v-on="on"
                    >
                    Actions
                    </v-btn>
                </template>
                <v-list>
                    
                    <return-to-pending-box :item="item" @update="update">
                        <template #activator="{on}">
                            <v-list-item v-on="on" :disabled="handling.status_id != 'on cart'">
                                <v-list-item-title>
                                    Return to Pending Box
                                </v-list-item-title>
                            </v-list-item>
                        </template>
                    </return-to-pending-box>
                    <mark-product-as-built :item="item" @update="update">
                        <template #activator="{on}">
                            <v-list-item v-on="on" :disabled="item.quantity <= item.built || handling.status_id != 'building'">
                                <v-list-item-title>
                                    Mark as built
                                </v-list-item-title>
                            </v-list-item>
                        </template>
                    </mark-product-as-built>
                    <mark-product-as-not-built :item="item" @update="update">
                        <template #activator="{on}">
                            <v-list-item v-on="on" :disabled="item.built == 0 || handling.status_id != 'building'">
                                <v-list-item-title>
                                    Mark as not built
                                </v-list-item-title>
                            </v-list-item>
                        </template>
                    </mark-product-as-not-built>
                </v-list>
                </v-menu>
        </template>
        <template #[`footer.prepend`]>
            <transfer-product-from-pending-box :handling="handling" @update="update" />
        </template>
    </v-data-table>
  </v-card>
</template>

<script>
import TransferProductFromPendingBox from './TransferProductFromPendingBox.vue'
import ReturnToPendingBox from './dialog/ReturnToPendingBox.vue'
import MarkProductAsBuilt from './dialog/MarkProductAsBuilt.vue';
import MarkProductAsNotBuilt from './dialog/MarkProductAsNotBuilt.vue';
export default {
    components: {
        TransferProductFromPendingBox,
        ReturnToPendingBox,
        MarkProductAsBuilt,
        MarkProductAsNotBuilt
    },
    props:{
        handling: {
            type: Object,
            required: true
        }
    },
    data: () => ({
        headers: [
            { text:'Product', value: 'product'},
            { text:'In cart', value: 'quantity'},
            { text:'Built', value: 'built'},
            { text:'', value: 'actions'},
        ]
    }),
    methods:{
        update () {
            this.$emit('update');
        }
    }
}
</script>

<style>

</style>
